import React, { useState } from "react";
import { Button, Empty, Modal } from "antd";
import { useFetch } from "../../Services/useFetch";
import { useEffect } from "react";

const CommentModal = ({
  commentModal,
  setCommentModal,
  showComments,
  currentItemData,
  selectedNodeData,
  setSelectedNodeData,
  handleAddCommentList,
}) => {
  const [value, setValue] = useState("");
  const [employeeListVal, setEmployeeListVal] = useState([]);
  // const [comment, setComment] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  const { request } = useFetch();

  const handleAddComment = async () => {
    const formData = new URLSearchParams();
    formData.append("file_id", currentItemData?.key);
    formData.append("folder_id", currentItemData?.parent_id);
    formData.append("commit", value);
    try {
      const response = await request("/comment-add", "post", formData, {
        "Content-Type": "application/x-www-form-urlencoded",
      });
      if (response?.data?.status == 1) {
        const updatedChildren = selectedNodeData?.children?.map((child) => {
          if (child.key === currentItemData.key) {
            return { ...child, commit_count: (child.commit_count || 0) + 1 };
          }
          return child;
        });
        setSelectedNodeData((prev) => ({
          ...prev,
          children: updatedChildren,
        }));
        setValue("");
        setCommentModal(false);
        handleAddCommentList(currentItemData);
      }
    } catch (error) {
      console.log(error, "error");
      setCommentModal(false);
      setValue("");
    }
  };

  const getUserList = async () => {
    try {
      const response = await request("/users-list-all", "get", null, {
        "Content-Type": "application/x-www-form-urlencoded",
      });

      if (response?.data?.status === "1") {
        setEmployeeListVal(response?.data?.data);
      }
    } catch (error) {}
  };
  useEffect(() => {
    getUserList();
  }, []);

  const handleChange = (e) => {
    const value = e.target.value;
    setValue(value);

    const match = value?.match(/@(\w*)$/);
    if (match) {
      const search = match[1]?.toLowerCase();
      const filtered = employeeListVal.filter((u) => u.firstname.toLowerCase().includes(search));
      setSuggestions(filtered);
      setShowDropdown(true);
    } else {
      setShowDropdown(false);
      setSuggestions([]);
    }
  };

  const handleSelectUser = (user) => {
    const updatedComment = value.replace(/@(\w*)$/, `@${user.firstname} `);
    setValue(updatedComment);
    setShowDropdown(false);
    setSuggestions([]);
  };

  return (
    <>
      <div className="comment_modal" style={{ position: "relative" }}>
        <Modal
          className="bd_commemnts_model"
          title={`Add your Comment here`}
          open={commentModal}
          onCancel={() => setCommentModal(false)}
          footer={[
            <div style={{ display: "flex", gap: "6px", padding: "6px" }} className="div_comment_input">
              <input
                // onChange={(e) => setValue(e.target.value)}
                value={value}
                placeholder="Add a comment"
                onChange={handleChange}
              />
              {suggestions.length > 0 && (
                <ul
                  style={{
                    position: "absolute",
                    top: "100%", // right below the textarea
                    left: 0,
                    width: "%",
                    backgroundColor: "white",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                    zIndex: 1000,
                    margin: 0,
                    padding: 0,
                    listStyle: "none",
                  }}
                >
                  {suggestions.map((user) => (
                    <li
                      key={user.id}
                      style={{
                        padding: "8px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleSelectUser(user)}
                    >
                      @{user.firstname}
                    </li>
                  ))}
                </ul>
              )}
              <Button
                icon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-chat"
                    viewBox="0 0 16 16"
                  >
                    <path d="M2.678 11.894a1 1 0 0 1 .287.801 11 11 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8 8 0 0 0 8 14c3.996 0 7-2.807 7-6s-3.004-6-7-6-7 2.808-7 6c0 1.468.617 2.83 1.678 3.894m-.493 3.905a22 22 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a10 10 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9 9 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105" />
                  </svg>
                }
                onClick={() => handleAddComment()}
                className=""
              >
                Add Comment
              </Button>
            </div>,
          ]}
        >
          <div className="bd_comment_container hide-scrollbar">
            {showComments.length > 0 ? (
              <>
                {showComments?.map((item, index) => {
                  return (
                    <div className={(index + 1) % 2 == 0 ? "bd_delete_spn_even" : "bd_delete_spn"}>
                      <p>
                        {item?.commit}
                        <span className="commented_by">
                          created at {item?.created_at} by {item?.user?.userfullname}
                        </span>
                      </p>
                    </div>
                  );
                })}
              </>
            ) : (
              <>
                <Empty />
              </>
            )}
          </div>
        </Modal>
      </div>
    </>
  );
};

export default CommentModal;
